import { Space } from 'antd'
import styled from 'styled-components'

const WideSpace = styled(Space)`
    width: 100%;
`

export default WideSpace
